import axios from "axios";
import Markdown from "markdown-to-jsx";
import React, { useEffect, useState } from "react";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { ContentApi } from "../../service/ServiceApi";
import { fontUnit, padGinUnit } from "../../utils/DeviceManager";

export function TermAndCondScreen() {

    const [consentDetail, setConsentDetail] = useState("")
    const getConsent = () => {
        axios.get(`${ContentApi.TERM_CONDITION}`).then(res => {
            setConsentDetail(res.data.description);
        })
    }

    useEffect(() => {
        document.title = "สมัครใช้งาน"
        getConsent();
    }, [])

    const termsAndConditionWidget = () => {
        return (
            <div style={{ overflow: "hidden", position: 'fixed', marginRight: '20px' }}>
                <div style={{
                    overflowY: "auto",
                    paddingBottom: padGinUnit(52)
                }}>
                    <DynamicTitle title={"ข้อกำหนดและเงื่อนไขการใช้บริการ Chaiyo Connect"} size={fontUnit(24)} isFull={true} align={"left"} />
                    <div
                        style={{
                            overflowY: "auto",
                            scrollbarGutter: "always",
                            height: window.innerHeight * 0.9 - 104,
                            backgroundColor: AcnColorTheme.white,
                            marginTop: padGinUnit(24),
                            padding: padGinUnit(8),
                            borderRadius: 8
                        }}
                    >
                        <div
                            style={{
                                fontFamily: "Thonburi",
                                color: AcnColorTheme.black,
                                textAlign: "start",
                                overflow: "auto",
                                padding: padGinUnit(4)
                            }}>
                            <Markdown
                                options={{
                                    overrides: {
                                        li: {
                                            props: {
                                                style: {
                                                    listStylePosition: 'inside'
                                                }
                                            }
                                        },
                                        ol: {
                                            props: {
                                                style: {
                                                    padding: 0
                                                }
                                            }
                                        }
                                    }
                                }}
                            >
                                {consentDetail ? consentDetail : "loading..."}
                            </Markdown>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <TemplateComponent content={termsAndConditionWidget()} />
    );
}